import { Tab, Tabs } from "react-bootstrap";

import ProdutosDesvinculados from "../ProdutosDesvinculados";
import ProdutosVinculados from "../ProdutosVinculados";
import { useRef } from "react";
import {
    ListarProdutosVinculadosPorVendaController,
    DeletarProdutoEquipeVendaController,
    ListarProdutosDesvinculadosPorVendaController,
    VincularProdutoEquipeVendaController,
} from "../../../../Controllers/Vendas/GestaoProdutosVinculadosController/GestaoProdutosVinculados";
import { IGestaoProdutosVinculados } from "../../../../Interfaces/Vendas/GestaoProdutoVinculados/GestaoProdutosVinculadosInterface";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface IEditarGrupoModalProps {
    idEquipeVendas: number;
    idProduto: number;
}

export default function VincularProdutosEquipeVenda(
    props: IEditarGrupoModalProps
) {
    const {
        execute: updateInsereEquipeVendasProdutoGestaoProdutos,
        loading: insereEtapaCategoriaGestaoProdutosLoading,
    } = useAsyncCallback(VincularProdutoEquipeVendaController, []);

    const lstSelecionadosGestaoProdutos = useRef<
        Array<IGestaoProdutosVinculados>
    >([]);

    function handleVincularTodosAtributoGestaoProdutos() {
        updateInsereEquipeVendasProdutoGestaoProdutos({
            ID_PRODUTO: lstSelecionadosGestaoProdutos.current.map(
                (selecionado) => selecionado.ID_PRODUTO
            ),
            ID_EQUIPE_VENDAS: props.idEquipeVendas,
        }).then(() => {
            ListarProdutosDesvinculadosPorVenda();
            ListarProdutosVinculadosPorVenda();
        });
    }

    function handleVincularAtributoUnicoGestaoProdutos(
        row: IGestaoProdutosVinculados
    ) {
        updateInsereEquipeVendasProdutoGestaoProdutos({
            ID_PRODUTO: [row.ID_PRODUTO],
            ID_EQUIPE_VENDAS: props.idEquipeVendas,
        }).then(() => {
            ListarProdutosDesvinculadosPorVenda();
            ListarProdutosVinculadosPorVenda();
        });
    }

    const {
        value: DesvincularEquipeProdutoGestaoProdutos,
        loading: DesvincularEquipeProdutoGestaoProdutosLoading,
        execute: ListarProdutosDesvinculadosPorVenda,
    } = useAsyncEffect(
        () =>
            ListarProdutosDesvinculadosPorVendaController(props.idEquipeVendas),
        []
    );

    const {
        execute: ListarProdutosVinculadosPorVenda,
        value: lstProdutosVinculadosPorVenda,
        loading: lstProdutosVinculadosPorVendaLoading,
    } = useAsyncEffect(
        () => ListarProdutosVinculadosPorVendaController(props.idEquipeVendas),
        [props.idEquipeVendas]
    );
    const lstSelecionadosDeleteGestaoProdutos = useRef<
        Array<IGestaoProdutosVinculados>
    >([]);
    function handleDesvincularTodosAtributoDeleteGestaoProdutos() {
        DeleteEquipeVendasGestaoProdutos({
            ID_PRODUTO: lstSelecionadosDeleteGestaoProdutos.current.map(
                (selecionado) => selecionado.ID_PRODUTO
            ),
            ID_EQUIPE_VENDAS: props.idEquipeVendas,
        }).then(() => {
            ListarProdutosVinculadosPorVenda();
            ListarProdutosDesvinculadosPorVenda();
        });
    }

    function handleDesvincularAtributoUnicoDeleteGestaoProdutos(
        row: IGestaoProdutosVinculados
    ) {
        DeleteEquipeVendasGestaoProdutos({
            ID_PRODUTO: [row.ID_PRODUTO],
            ID_EQUIPE_VENDAS: props.idEquipeVendas,
        }).then(() => {
            ListarProdutosVinculadosPorVenda();
            ListarProdutosDesvinculadosPorVenda();
        });
    }

    const {
        execute: DeleteEquipeVendasGestaoProdutos,
        loading: DeleteEquipeVendasLoadingGestaoProdutos,
    } = useAsyncCallback(DeletarProdutoEquipeVendaController);
    return (
        <>
            <Tabs defaultActiveKey="vinculadas" unmountOnExit>
                <Tab
                    title="Unidades Vinculadas"
                    eventKey="vinculadas"
                    mountOnEnter
                >
                    <div className="p-5">
                        <ProdutosVinculados
                            idEquipeVendas={props.idEquipeVendas}
                            DeleteEquipeVendasLoadingGestaoProdutos={
                                DeleteEquipeVendasLoadingGestaoProdutos
                            }
                            ListarProdutosVinculadosPorVenda={
                                ListarProdutosVinculadosPorVenda
                            }
                            handleDesvincularAtributoUnicoDeleteGestaoProdutos={
                                handleDesvincularAtributoUnicoDeleteGestaoProdutos
                            }
                            handleDesvincularTodosAtributoDeleteGestaoProdutos={
                                handleDesvincularTodosAtributoDeleteGestaoProdutos
                            }
                            lstProdutosVinculadosPorVenda={
                                lstProdutosVinculadosPorVenda
                            }
                            lstProdutosVinculadosPorVendaLoading={
                                lstProdutosVinculadosPorVendaLoading
                            }
                            lstSelecionadosDeleteGestaoProdutos={
                                lstSelecionadosDeleteGestaoProdutos
                            }
                        />
                    </div>
                </Tab>
                <Tab
                    title="Unidades Desvinculadas"
                    eventKey="desvinculadas"
                    mountOnEnter
                >
                    <div className="p-5">
                        <ProdutosDesvinculados
                            idEquipeVendas={props.idEquipeVendas}
                            idProduto={props.idEquipeVendas}
                            DesvincularEquipeProdutoGestaoProdutos={
                                DesvincularEquipeProdutoGestaoProdutos
                            }
                            DesvincularEquipeProdutoGestaoProdutosLoading={
                                DesvincularEquipeProdutoGestaoProdutosLoading
                            }
                            handleVincularAtributoUnicoGestaoProdutos={
                                handleVincularAtributoUnicoGestaoProdutos
                            }
                            handleVincularTodosAtributoGestaoProdutos={
                                handleVincularTodosAtributoGestaoProdutos
                            }
                            insereEtapaCategoriaGestaoProdutosLoading={
                                insereEtapaCategoriaGestaoProdutosLoading
                            }
                            lstSelecionadosGestaoProdutos={
                                lstSelecionadosGestaoProdutos
                            }
                        />
                    </div>
                </Tab>
            </Tabs>
        </>
    );
}
